import React from "react";
import { useI18n } from "@core/i18n/i18n";
import { Control, Controller } from "react-hook-form";
import { CountryLanguageInput } from "@ui/components/inputs/country-language-input/country-language-input";

interface CountryLanguagesFieldProps {
	name: string;
	control: unknown;
	locales: Map<string, string[]>;
	labelStyle?: React.CSSProperties;
}

export const CountryLanguagesField = ({
	name,
	control,
	locales,
	labelStyle,
}: CountryLanguagesFieldProps): JSX.Element => {
	const { format } = useI18n();

	return (
		<Controller
			name={name}
			control={control as Control<{ [key: string]: string }, object>}
			render={({ field }) => (
				<>
					<label style={labelStyle} className="p-size-m">
						{format("passwordField.countryLanguage.label")}
					</label>
					<CountryLanguageInput locales={locales} placeholder={format("global.form.dropdown.placeholder")} {...field} />
				</>
			)}
		/>
	);
};
